<style lang="scss" scoped>
.char-count {
    color: black;
    font-weight: normal;
    font-size: 0.9em;
}
.session{
    border: 2px solid #91ccda;
}

</style>

<template>
  <div id="addNewSession">
    <p>Please enter a name for your training session. The name should be unique (examples: Martha A. Infant Classroom, Little Lambs Morning Session). This will help you find and print training certificates once the training is complete.</p>
    <div class="form-group">
      <label>Session Name <span class="char-count">(Max {{ maxSessionTitleLength }} characters. {{ maxSessionTitleLength - sessionTitle.length }} remaining)</span></label>
      <input type="text" class="session" ref="sessionTitle" v-model="sessionTitle" :maxlength="maxSessionTitleLength" />
    </div>
    <div class="form-group">
      <label>Time</label>
       <datetime input-class="session-date" class="session" ref="sessionDate" v-model="sessionDate"
            type="datetime"
            :auto="true"
            :format="{ year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }"
            :minute-step="15"
            use12-hour
        >
            <template #button-confirm="{ scope }">
              <span v-if='scope.step === "date"'>Next <i class='fas fa-arrow-right' /></span>
              <span v-else><i class='fas fa-check-circle' /> Publish</span>
            </template>
             <template slot="button-cancel">
              <span class="text-danger">
                <i class="fa fa-times"></i>
                Cancel
              </span>
            </template>
        </datetime>
    </div>
    <div>
      <button type="button" @click="submitNewSession" class="btn bg-orange text-white float-right"><span v-html="submitTemplate"></span></button>
    </div>
  </div>
</template>

<script>
    import { Datetime } from 'vue-datetime3';
    import { computed } from 'vue';
    import { useStore } from 'vuex';
    import { mapMutations } from 'vuex';

    export default{
        components: {
            'datetime': Datetime,
        },
        props: {
            trainingId: {
                type: Number,
                default: null,
                required: true
            },
            newSession: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                sessionTitle: "",
                sessionDate: null,
                loading: false,
            }
        },
        methods: {
            submitNewSession() {
                if(!this.validate()) {
                    return;
                };

                this.loading = true;
                let vm = this;

                let data = {
                    title: this.sessionTitle ? this.sessionTitle : "Session on " + moment(this.sessionDate).format('MM/DD/YY'),
                    start_time: this.sessionDate
                };
                axios.post('provider-trainings/' + this.trainingId + '/training-session', data)
                .then(response => {
                    let trainingSession = response.data.trainingSession;
                    const payload = {
                        trainingId: this.trainingId,
                        trainingSessionId: trainingSession.id, 
                        trainingSession,
                        isNew: true
                      };
                    this.$store.commit('ADD_NEW_SESSION', payload);
                    this.$emit('add-new-session');
                });
            },
            validate() {
                if(!this.sessionTitle) {
                    this.$refs.sessionTitle.setCustomValidity("Please enter a name for your training session.");
                    this.$refs.sessionTitle.reportValidity();
                    return false;
                }

                if(!this.sessionDate) {
                    this.$refs.sessionDate.$el.querySelector('input').setCustomValidity("Please select a date and time for this session.");
                        this.$refs.sessionDate.$el.querySelector('input').reportValidity();
                    return false;
                }

                this.$refs.sessionTitle.setCustomValidity("");
                this.$refs.sessionDate.$el.querySelector('input').setCustomValidity("");
                this.$refs.sessionDate.$el.querySelector('input').reportValidity();
                return true;
            }
        },
        computed: {
            submitTemplate() {
                if(this.loading) {
                    return "<i class='fa fa-spin fa-spinner' aria-hidden='true'></i>";
                }
                return "Submit";
            },
            maxSessionTitleLength() {
                return 150;
            }
        },
        watch: {
            newSession: {
                immediate: true,
                handler: function(newVal, oldVal) {
                    if(newVal) {
                        this.sessionTitle = "";
                        this.sessionDate = null;
                        this.loading = false;
                    }
                }
            }
        }
    }
</script>